//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        ibsinbound: [],
        searchRequest: {},
      },

      mutations: {
        updateibsInbound(state, ibsinbound) {
          state.ibsinbound = ibsinbound;
        },
        updateSearchibsibRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async ibsInboundsList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          if (requestToSend.apptDate.startDate)
          {
            requestToSend.apptDate.startDate = dateFormat.getLocalDateOnly(requestToSend.apptDate.startDate);
          }

          if (requestToSend.apptDate.endDate)
          {
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.endDate);
          }
          else{
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.startDate);
          }

          if (requestToSend.ibs_process_DT.startDate)
          {
            requestToSend.ibs_process_DT.startDate = dateFormat.getLocalDateOnly(requestToSend.ibs_process_DT.startDate);
          }

          if (requestToSend.ibs_process_DT.endDate)
          {
            requestToSend.ibs_process_DT.endDate = dateFormat.getLocalDateEnd(requestToSend.ibs_process_DT.endDate);
          }
          else{
            requestToSend.ibs_process_DT.endDate = dateFormat.getLocalDateEnd(requestToSend.ibs_process_DT.startDate);
          }

          if (requestToSend.po_lsd.startDate)
          {
            requestToSend.po_lsd.startDate = dateFormat.getLocalDateOnly(requestToSend.po_lsd.startDate);
          }

          if (requestToSend.po_lsd.endDate)
          {
            requestToSend.po_lsd.endDate = dateFormat.getLocalDateEnd(requestToSend.po_lsd.endDate);
          }

          if (requestToSend.ciDate)
          {
            requestToSend.ciDate = dateFormat.getLocalDateOnly(requestToSend.ciDate);
          }

          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/GetIBSInboundNew', requestToSend);
          const result = await newAPIPost('/api/w/fsi/GetIBSInboundNew', requestToSend);
          //const result = await api.post('/api/w/fsi/GetIBSInboundNew', requestToSend);
          commit('updateSearchibsibRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateibsInbound', result);
                },
      },

      getters: {
        getibsInbound: state => state.ibsinbound,
      },
}
